import React from 'react';

const SIZES = { sm: 'w-5 h-5 border-2', md: 'w-10 h-10 border-[3px]', lg: 'w-16 h-16 border-4' };

const Spinner = ({ size = 'md', className = '' }) => (
    <div className={`relative ${SIZES[size]} ${className}`}>
        <div className={`absolute inset-0 rounded-full border-slate-200/40 dark:border-slate-700/40 ${SIZES[size]}`} />
        <div
            className={`absolute inset-0 rounded-full border-transparent border-t-slate-900 dark:border-t-white animate-spin ${SIZES[size]}`}
        />
    </div>
);

export default Spinner;
